// extracted by mini-css-extract-plugin
export default {"userStatusContainer":"UserStatus_userStatusContainer__EnJJp","left":"UserStatus_left__MeeE0","right":"UserStatus_right__DpoMv","aboutUser":"UserStatus_aboutUser__h7YWT"};